import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import resolveQueryStringToRecipient from '../actions/resolveQueryStringToRecipient';

export default function searchDirectory(
    recipientWell: RecipientWellWithFindControlViewState
): void {
    resolveQueryStringToRecipient(
        recipientWell,
        false /* shouldDirectlyResolve */,
        true /* searchDirectory */
    );
}
